import { ActionBlockingResponse } from "./action-blocking-response.model";

export class AvDisruptionActionBlockingResponse extends ActionBlockingResponse {
  disruptedPackageUserGuids: string[];

  static [Symbol.hasInstance](obj: any): boolean {
    return obj.disruptedPackageUserGuids !== undefined;
  }
}
